// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3xn8b","info":"UpdateTermsInfo_info__3pV_1"};